import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation CreateTransfer($input: CreateTransferInput!) {
    transfer {
      createTransfer(input: $input) {
        __typename
        ... on CreateTransferSuccess {
          transfer {
            transferId
          }
        }
        ... on CreateTransferFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdateTransfer($input: UpdateTransferInput!) {
    transfer {
      updateTransfer(input: $input) {
        __typename
        ... on UpdateTransferSuccess {
          transfer {
            transferId
          }
        }
        ... on UpdateTransferFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation CancelTransfer($input: CancelTransferInput!) {
    transfer {
      cancelTransfer(input: $input) {
        __typename
        ... on CancelTransferSuccess {
          transfer {
            transferId
          }
        }
        ... on CancelTransferFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ConfirmTransferWorkOrder($input: ConfirmTransferWorkOrderInput!) {
    transfer {
      confirmTransferWorkOrder(input: $input) {
        __typename
        ... on ConfirmTransferWorkOrderSuccess {
          transfer {
            transferId
          }
        }
        ... on ConfirmTransferWorkOrderFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdateTransferPalletLpns($input: UpdateTransferPalletLpnsInput!) {
    transfer {
      updateTransferPalletLpns(input: $input) {
        __typename
        ... on UpdateTransferPalletLpnsSuccess {
          transfer {
            transferId
          }
        }
        ... on UpdateTransferPalletLpnsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation AdvanceTransfer($input: AdvanceTransferInput!) {
    transfer {
      advanceTransfer(input: $input) {
        __typename
        ... on AdvanceTransferSuccess {
          transfer {
            transferId
          }
        }
        ... on AdvanceTransferFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
